export default __webpack_public_path__ + "static/media/enfermeria.6d233b62.jpg";